var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(false)?_c('div',{class:_vm.theme},[_c('Preloader',{attrs:{"delay":100,"maxProgress":100,"progress":_vm.preloaderProgress,"update":10}})],1):_vm._e(),(true)?_c('div',[(_vm.isTerminal)?_c('v-app',[_c('router-view')],1):_c('div',{staticClass:"application-wrapper"},[_c('router-view')],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }